import { VisitEncounterMode } from '@dreryk/egabinet-visit-frontend-api';

import { assertUnreachable } from '@dreryk/react-common';
import {
   IconFillColor,
   IconWrapper,
   MapMarkerIcon,
   TestId,
   Tooltip,
   TooltipContent,
   VideoConsultationIcon,
} from '@dreryk/react-components';

import { appointmentsTranslationKeys } from '../../../translations';

type IconRendererProps = Readonly<{
   testId: TestId;
   icon: JSX.Element;
   tooltipContent: TooltipContent;
}>;

type EncounterModeCellProps = Readonly<{
   encounterMode: VisitEncounterMode;
}>;

export const EncounterModeCell = (props: EncounterModeCellProps): JSX.Element => {
   const renderIcon = (props: IconRendererProps): JSX.Element => {
      return (
         <Tooltip testId={props.testId} content={props.tooltipContent}>
            <IconWrapper testId={props.testId} fillColor={IconFillColor.BACKGROUND}>
               {props.icon}
            </IconWrapper>
         </Tooltip>
      );
   };

   switch (props.encounterMode) {
      case 'ON_SITE':
         return renderIcon({
            icon: <MapMarkerIcon />,
            testId: 'onSite',
            tooltipContent: appointmentsTranslationKeys.visitEncounterModeMap.ON_SITE,
         });
      case 'VIDEO_CONSULTATION':
         return renderIcon({
            icon: <VideoConsultationIcon />,
            testId: 'videoConsultation',
            tooltipContent: appointmentsTranslationKeys.visitEncounterModeMap.VIDEO_CONSULTATION,
         });
      default:
         return assertUnreachable(props.encounterMode);
   }
};
